type TranslateFn = (key: string, params?: Record<string, string>) => string;

export const formatList = (items: string[], t: TranslateFn): string => {
  if (items.length <= 1) return items[0] ?? '';

  const head = items.slice(0, -1).join(', ');
  return `${head} ${t('common.and')} ${items[items.length - 1]}`;
};

export const formatTruncatedList = (items: string[], t: TranslateFn, limit: number): string => {
  if (items.length <= limit + 1) return formatList(items, t);

  const hiddenCount = items.length - limit;
  return formatList(
    [...items.slice(0, limit), t('common.countOthers', { amount: String(hiddenCount) })],
    t,
  );
};
